import { render } from "./MapsList.vue?vue&type=template&id=a4a54c12"
import script from "./MapsList.vue?vue&type=script&lang=js"
export * from "./MapsList.vue?vue&type=script&lang=js"

import "./MapsList.vue?vue&type=style&index=0&id=a4a54c12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__